import { useState } from "react";
import { Navigate, useNavigate } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import { updateAccountType } from "../../api/auth.api";
import { useAuthStore } from "../../stores/auth.store";

export function RegisterPage() {
  const { user, isLoading, isAuthenticated } = useAuth();
  const setUser = useAuthStore((s) => s.setUser);
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  if (isLoading) {
    return (
      <div className="flex justify-center py-16">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-gray-900" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  async function selectAccountType(type: "user" | "business") {
    setSubmitting(true);
    try {
      const { user: updated } = await updateAccountType(type);
      setUser(updated);
      navigate(type === "business" ? "/dashboard/settings" : "/explore");
    } catch {
      setSubmitting(false);
    }
  }

  return (
    <div className="mx-auto max-w-md py-16">
      <h1 className="mb-2 text-center text-2xl font-bold">
        Welcome, {user?.name}!
      </h1>
      <p className="mb-8 text-center text-gray-600">
        How will you use Abejón?
      </p>

      <div className="space-y-4">
        <button
          onClick={() => selectAccountType("user")}
          disabled={submitting}
          className="w-full rounded-lg border-2 border-gray-200 p-6 text-left hover:border-gray-900 disabled:opacity-50"
        >
          <div className="text-lg font-semibold">Customer</div>
          <p className="mt-1 text-sm text-gray-600">
            Book appointments, discover businesses, and interact with posts
          </p>
        </button>

        <button
          onClick={() => selectAccountType("business")}
          disabled={submitting}
          className="w-full rounded-lg border-2 border-gray-200 p-6 text-left hover:border-gray-900 disabled:opacity-50"
        >
          <div className="text-lg font-semibold">Business</div>
          <p className="mt-1 text-sm text-gray-600">
            Create your profile, manage services, accept bookings, and post content
          </p>
        </button>
      </div>
    </div>
  );
}
